// extracted by mini-css-extract-plugin
export default {"LoadingSpinner":"LoadingSpinner_zpfQR"};